import React, { FC, useEffect, useState } from 'react';
import { Category } from 'shared/types/product/Category';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import useClassNames from 'helpers/hooks/useClassNames';
import { NationalSemibold } from 'fonts';


export interface Props {
  show: boolean;
  link: any;
  updateSubMenu: () => void;
}

const HeaderNavigationButtonDesktop: FC<Props> = ({ show, link, updateSubMenu }) => {

  const [isHovered, setIsHovered] = useState(false);

  const navLinkClassNames = useClassNames([
    'flex py-4 cursor-pointer relative items-center justify-evenly',
    
  ]);


  return (
    <div
      onClick={updateSubMenu}
      className="3xl:h-52 px-4 py-6 3xl:py-12 xl:px-10 "
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className={navLinkClassNames}>
        <Typography as="span" className={`text-16 font-semibold text-[#fff] 2xl:text-20 ${NationalSemibold.className}`}>
          {link?.label}
        </Typography>
        {link?.mega_menu && link?.mega_menu?.submenu_links.length > 0 && (
          <>
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 18 18" fill="none" className={`ml-2 xl:ml-5 w-14 2xl:w-16 text-secondary-black ${show ? 'rotate-180' : 'ml-2 xl:ml-5'}`}>
            <path d="M15.2863 5.85742L9.00056 12.1431L2.71484 5.85742" 
              stroke="#FFFFFF" strokeWidth="1.57143" strokeLinecap="square"/>
          </svg>
            
          
          {/* <ChevronDownIcon className={`ml-2 xl:ml-5 w-14 2xl:w-16 text-secondary-black ${show ? 'rotate-180' : ' mt-2'}`} />
            )} */}
        </>
      )}
      </span>
    </div>
  );
};
export default HeaderNavigationButtonDesktop;
